// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"197":"3e1cee6182af06a4f78a","926":"addec95810bb167ef95b"}[chunkId] + ".js";
};